export enum LoopWorkerActions {
  Start = 'start',
  Stop = 'stop',
  Destroy = 'destroy'
}
